import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

export const toast = (type, msg) => {
    if ( type === 'success') {
       return NotificationManager.success(msg, '', 2000);
    }
    return NotificationManager.error(msg,  '', 2000);
};